import { render, staticRenderFns } from "./DialogComponent.vue?vue&type=template&id=1ac7e8d4&scoped=true"
import script from "./DialogComponent.vue?vue&type=script&lang=js"
export * from "./DialogComponent.vue?vue&type=script&lang=js"
import style0 from "@/other/assets/css/app.css?vue&type=style&index=0&id=1ac7e8d4&prod&scoped=true&lang=css&external"
import style1 from "./DialogComponent.vue?vue&type=style&index=1&id=1ac7e8d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac7e8d4",
  null
  
)

export default component.exports